var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { HTTP_METHODS } from "../common/enums/http-methods";
import { I18nLangs } from "../common/enums/i18-langs";
import { LocalStorageKeys } from "../common/enums/local-storage-keys";
export var baseURL = process.env.REACT_APP_API_I18_URL || "";
var ApiI18Config = /** @class */ (function () {
    function ApiI18Config() {
    }
    ApiI18Config.headers = function (headersParams) {
        return __assign({ Accept: "application/json", "Content-Type": "application/json" }, headersParams);
    };
    ApiI18Config.get = function (route, key, options) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(route, null, HTTP_METHODS.GET, key, options)];
            });
        });
    };
    ApiI18Config.post = function (route, params, key, options) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(route, params, HTTP_METHODS.POST, key, options)];
            });
        });
    };
    ApiI18Config.request = function (route, params, verb, key, opts) {
        return __awaiter(this, void 0, Promise, function () {
            var url_1, options_1, url, options, keys, Authorization;
            return __generator(this, function (_a) {
                if (route.match("http(s)?://")) {
                    url_1 = "".concat(route);
                    options_1 = { method: verb, params: params };
                    return [2 /*return*/, axios(url_1, options_1)];
                }
                url = "".concat(baseURL).concat(route);
                options = __assign({ data: params, method: verb }, opts);
                keys = key ? __assign({}, key) : {};
                if (localStorage.getItem(LocalStorageKeys.SELECTED_LANG)) {
                    keys["Content-Language"] = (localStorage.getItem(LocalStorageKeys.SELECTED_LANG) || I18nLangs.EN).toUpperCase();
                }
                Authorization = localStorage.getItem('Authorization_gad24');
                if (Authorization) {
                    keys.Authorization = Authorization;
                }
                if (localStorage.getItem('Authorization_gad24')) {
                    keys['X-Gad-Api-Auth'] = localStorage.getItem('Authorization_gad24');
                }
                options.headers = ApiI18Config.headers(keys);
                return [2 /*return*/, axios(url, options)];
            });
        });
    };
    return ApiI18Config;
}());
export default ApiI18Config;
